var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
var messages = defineMessages({
    unavailable_coef: {
        id: 'unavailable.coef',
        defaultMessage: 'Коэффицент не доступен'
    },
    coupon_coefficient_changed: {
        id: 'coupon.coefficient_changed',
        defaultMessage: 'Коэффициент изменился!'
    },
    insufficient_funds: {
        id: 'bet_history.errors.insufficient_funds',
        defaultMessage: 'Недостаточно средств на балансе'
    },
    try_bet_again: {
        id: 'try_bet.again',
        defaultMessage: 'Попробуйте сделать ставку ещё раз.'
    },
    empty_close: {
        id: 'coupon.empty_close',
        defaultMessage: 'Закрыть'
    },
});
var UnavailableRate = function (props) {
    if (props.showErrorIcon) {
        var errorMsg = '';
        if (props.unavailable) {
            errorMsg = _jsx("div", __assign({ className: 'title' }, { children: _jsx(FormattedMessage, __assign({}, messages.unavailable_coef)) }));
        }
        else if (props.errorCode === 2) {
            errorMsg = _jsx("div", __assign({ className: 'title' }, { children: _jsx(FormattedMessage, __assign({}, messages.coupon_coefficient_changed)) }));
        }
        else if (props.errorCode === 1) {
            errorMsg = _jsx("div", __assign({ className: 'title' }, { children: _jsx(FormattedMessage, __assign({}, messages.insufficient_funds)) }));
        }
        return (_jsxs("div", __assign({ className: 'unavailable-coef' }, { children: [_jsx("div", { className: "icon" }), errorMsg, _jsx("div", __assign({ className: 'sub' }, { children: _jsx(FormattedMessage, __assign({}, messages.try_bet_again)) })), _jsx("div", __assign({ className: 'controls' }, { children: _jsx("button", __assign({ onClick: props.close }, { children: _jsx(FormattedMessage, __assign({}, messages.empty_close)) })) }))] })));
    }
    else {
        return (_jsx("div", __assign({ className: 'unavailable-coef' }, { children: props.children })));
    }
};
export default UnavailableRate;



// WEBPACK FOOTER //
// ./src/components/coupon/UnavailableRate.jsx